var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cv-dropdown',{attrs:{"value":_vm.selected},on:{"change":(id) =>
      _vm.$emit('update', {
        ..._vm.items.find((item) => item.id.toString() === id),
      })}},_vm._l((_vm.items),function(item){return _c('cv-dropdown-item',{key:item.id,attrs:{"value":item.id.toString()}},[_c('pre',{style:({
        backgroundColor: '#393939',
        overflow: 'hidden',
        paddingTop: '2px',
        paddingBottom: '5px',
      })},[_vm._v(_vm._s(item.label))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }